import {DefaultSeoProps} from 'next-seo'
import {SITE_CONFIG} from './utils/helpers'

const {entity, canonicalUrl, siteName} = SITE_CONFIG
export const defaultSEO: DefaultSeoProps =
  entity === 'cz'
    ? {
        title: 'Vyberte si svého terapeuta',
        description: 'Vyberte si svého terapeuta z ověřených odborníků.',
        themeColor: '#D1F8FF',
        openGraph: {
          type: 'website',
          locale: 'cs_CZ',
          url: canonicalUrl,
          siteName,
        },
        twitter: {
          site: canonicalUrl,
          cardType: 'summary_large_image',
        },
      }
    : {
        title: 'Vyber si svojho psychológa',
        description: 'Vyber si svojho psychológa z overených odborníkov.',
        themeColor: '#D1F8FF',
        openGraph: {
          type: 'website',
          locale: 'sk_SK',
          url: canonicalUrl,
          siteName,
        },
        twitter: {
          site: canonicalUrl,
          cardType: 'summary_large_image',
        },
      }
